export const FLIGHT_MODES = {
  TAKEOFF: 1, // 이륙
  MOVE: 2,    // 이동
  LANDING: 3  // 착륙
};

export const SCROLL_SPEED = 10;  // 스크롤 속도
export const SCROLL_THRESHOLD = 50;  // 마우스가 테이블 상단/하단에서 스크롤을 시작하는 거리

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY; // Google Maps API 키

// 환경별 API URL 설정
export const API_BASE_URL = process.env.NODE_ENV === "production"
  ? "https://tlatfarm-api-281189600745.asia-northeast3.run.app" // 클라우드 런 백엔드 URL
  : "";

export const DEFAULT_MAP_CENTER = { lat: 35.222172, lng: 126.847596 };
export const DEFAULT_MAP_LEVEL = 3;
export const HEADER_HEIGHT = "15vh";
